// extracted by mini-css-extract-plugin
export var container = "_34-1";
export var editor = "_34-2";
export var resizable = "_34-3";
export var wrapper = "_34-0";